<template>
  <div class="flex my-6" :class="{ 'h-11': !testing, 'space-x-2.5 h-9': testing }">
    <OLink
      pure
      class="flex-1 u-center bg-[#4363A2] rounded-l-lg"
      :href="`http://www.facebook.com/sharer/sharer.php?u=${articleUrl}`"
      @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Fbshare')"
    >
      <OIcon icon="article/facebook-white" svg-class="w-5 h-5" />
    </OLink>
    <OLink
      pure
      class="flex-1 u-center bg-[#60B5F1]"
      :href="`https://twitter.com/intent/tweet?via=${TWITTER_USERNAME}&url=${articleUrl}&text=${article.title}`"
      @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Twittershare')"
    >
      <OIcon icon="article/twitter-white" svg-class="w-5 h-5" />
    </OLink>
    <OLink
      pure
      class="flex-1 u-center bg-[#25D366]"
      :href="`whatsapp://send?text=${article.title} ${articleUrl}`"
      @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Whatsappshare')"
    >
      <OIcon icon="article/whatsapp-white" svg-class="w-5 h-5" />
    </OLink>
    <OLink
      pure
      class="flex-1 u-center bg-[#2EA2D8]"
      :href="`https://t.me/share/url?url=${articleUrl}&text=${article.title}`"
      @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Telegramshare')"
    >
      <OIcon icon="article/telegram-white" svg-class="w-5 h-5" />
    </OLink>
    <OLink
      pure
      class="flex-1 u-center bg-[#4486F4]"
      href="https://news.google.com/publications/CAAqBwgKMIGmrAsw_rDEAw?ceid=TR:tr&oc=3&hl=tr&gl=TR"
      rel="noopener noreferrer nofollow"
      @click="$analyticsEvent('Detailpage', 'User_Engagement', 'detailpage_Googlenews')"
    >
      <OIcon icon="article/google-white" svg-class="w-5 h-5" />
    </OLink>
    <OButton pure class="flex-1 u-center bg-[#9B9B9B] rounded-r-lg" @click="shareArticle()">
      <OIcon icon="article/link-white" svg-class="w-5 h-5" />
    </OButton>
  </div>
</template>

<script>
import { computed, defineComponent, inject, useContext } from '@nuxtjs/composition-api';
import { OButton, OLink, OIcon } from '~/modules/common/components/ui';
import { openExternalPopup } from '~/modules/common/utils/helpers';
import { HOST_URL, TWITTER_USERNAME } from '~/constants/config';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { useToast } from '~/composables/useModal';

export default defineComponent({
  props: {
    testing: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
  },
  components: { OButton, OLink, OIcon },
  setup(props) {
    const article = props.testing ? props.item : inject('article');
    const { toastSuccess } = useToast();
    const { i18n } = useContext();

    const articleUrl = computed(() => HOST_URL + getArticleUrl({ article }));

    const shareArticle = () => {
      if (navigator.share) {
        navigator
          .share({
            title: article.title,
            url: articleUrl.value,
          })
          .catch(console.error);
      } else {
        // fallback navigator.share
        const copy = require('copy-to-clipboard');
        copy(articleUrl.value);
        toastSuccess(i18n.t('main.copied'));
      }
    };

    return {
      article,
      articleUrl,
      openExternalPopup,
      shareArticle,
      TWITTER_USERNAME,
    };
  },
});
</script>
